import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton"; // same button style as other forms
import "./UnifiedFormStyles.css";
import { submitPartialForm, updateForm } from "../../Helpers/API/formsAPI";
import { getRegionConfig } from "./config/regionConfig";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";

function JoiningMayaMallProgramSection72({
  navigation,
  primaryDetails,
  setPrimaryDetails,
}) {
  const navigate = useNavigate();
  const [isError, setIsError] = useState({});
  const [isUploading, setIsUploading] = useState(false);

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        acknowledgement_receipt_temp_path: uploadResult.temp_path
      }));
      if (isError.acknowledgement_receipt) {
        setIsError(prev => ({ ...prev, acknowledgement_receipt: false }));
      }
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  // Set today's date as default for date_signed
  useEffect(() => {
    if (!primaryDetails.date_signed) {
      const today = new Date().toISOString().split("T")[0];
      setPrimaryDetails((prev) => ({
        ...prev,
        date_signed: today,
      }));
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (isError[name]) {
      setIsError((prev) => ({ ...prev, [name]: false })); 
    }
  };


  const validateForm = () => {
    const errors = {};
    
    // Only validate acknowledgement_receipt if not DCC only
    if (primaryDetails.joined_maya_program !== "Yes, DCC only") {
      if (!primaryDetails.acknowledgement_receipt_temp_path) {
        errors.acknowledgement_receipt = true;
      }
      if (!primaryDetails.program_participation) {
        errors.program_participation = true;
      }
    }
      
    // Only validate these fields if not Flagship Store
    if (primaryDetails.program_participation !== "Flagship Store") {
      if (!primaryDetails.preferred_incentive) errors.preferred_incentive = true;
      if (!primaryDetails.mobile_number) errors.mobile_number = true;
      // if (!primaryDetails.total_terminals_joined) errors.total_terminals_joined = true;
      // if (!primaryDetails.mid_terminals_joined) errors.mid_terminals_joined = true;
      
      // Only validate SQR fields if not DCC only and not Flagship Store
      // if (primaryDetails.joined_maya_program !== "Yes, DCC only") {
      //   // if (!primaryDetails.total_sqr_joined) errors.total_sqr_joined = true;
      //   // if (!primaryDetails.store_code_sqr) errors.store_code_sqr = true;
      // }
      
      // if (!primaryDetails.poc_name) errors.poc_name = true;
      // if (!primaryDetails.poc_position) errors.poc_position = true;
      if (!primaryDetails.date_signed) errors.date_signed = true;
    }
    
    // Only require reason if NOT joining Mall Champion (Ex: not Mall Champion or Both)
    if (!["Mall Champion", "Both"].includes(primaryDetails.program_participation) &&
      primaryDetails.program_participation !== "Flagship Store" &&
      !primaryDetails.reason_not_joined_mall_champion
    ) {
      errors.reason_not_joined_mall_champion = true;
    }
    
    // Validate Maya Kita Club fields based on selection
    if (!primaryDetails.joined_maya_kita_club) {
      errors.joined_maya_kita_club = true;
    } else {
      // Only validate facebook_accnt_name if joined_maya_kita_club is "Yes"
      if (primaryDetails.joined_maya_kita_club === "Yes" && !primaryDetails.facebook_accnt_name) {
        errors.facebook_accnt_name = true;
      }
      // Only validate reason_not_joined_maya_kita_club if joined_maya_kita_club is "No"
      if (primaryDetails.joined_maya_kita_club === "No" && !primaryDetails.reason_not_joined_maya_kita_club) {
        errors.reason_not_joined_maya_kita_club = true;
      }
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    // Only validate acknowledgement_receipt if not DCC only
    if (primaryDetails.joined_maya_program !== "Yes, DCC only") {
      if (!primaryDetails.acknowledgement_receipt_temp_path) return false;
      if (!primaryDetails.program_participation) return false;
    }

    // Only validate these fields if not Flagship Store
    if (primaryDetails.program_participation !== "Flagship Store") {
      if (!primaryDetails.preferred_incentive) return false;
      if (!primaryDetails.mobile_number) return false;
      if (!primaryDetails.date_signed) return false;
    }

    // Only require reason if NOT joining Mall Champion
    if (
      !["Mall Champion", "Both"].includes(primaryDetails.program_participation) &&
      primaryDetails.program_participation !== "Flagship Store" &&
      !primaryDetails.reason_not_joined_mall_champion
    ) {
      return false;
    }

    // Maya Kita Club validation
    if (!primaryDetails.joined_maya_kita_club) {
      return false;
    } else {
      if (primaryDetails.joined_maya_kita_club === "Yes" && !primaryDetails.facebook_accnt_name) {
        return false;
      }
      if (primaryDetails.joined_maya_kita_club === "No" && !primaryDetails.reason_not_joined_maya_kita_club) {
        return false;
      }
    }

    return true;
  };

  const handleNext = () => {
      if (validateForm()) {
        navigation.go("competitor-priority");
      } else {
        toast.error("Please fill in all required fields.");
      }
    };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">JOINING MAYA MALL PROGRAM</h4>
              <p className="form-desc">
                Please fill in all the required details
              </p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* Acknowledgment Receipt Photo - Hidden for DCC only */}
                  {primaryDetails.joined_maya_program !== "Yes, DCC only" && (
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label">
                        Acknowledgment Receipt (AR) of Maya Mall Program
                        Participation photo{" "}
                        <span className="form-required">*</span>
                        {primaryDetails.acknowledgement_receipt_temp_path && !isUploading && (
                          <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                        )}
                      </Form.Label>
                      <Form.Text className="form-hint">
                        Upload all pages of Acknowledgment Receipt
                      </Form.Text>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoUpload}
                        isInvalid={isError.acknowledgement_receipt}
                        disabled={isUploading}
                      />
                      {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                      {isError.acknowledgement_receipt && (
                        <div className="form-error">Required</div>
                      )}
                    </Form.Group>
                  )}

                  
                  {/* Maya Mall Program participation */}
                  {primaryDetails.joined_maya_program !== "Yes, DCC only" && (
                  <Form.Group
                    className="mb-4"
                    controlId="program_participation"
                  >
                    <Form.Label className="form-label">
                      Maya Mall Program participation{" "}
                      <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Select
                      name="program_participation"
                      value={primaryDetails.program_participation || ""}
                      onChange={handleInputChange}
                      className={`form-input ${isError.program_participation ? "form-input-error" : ""}`}
                    >
                      <option value="">-- Select an option --</option>
                      <option value="Mall Champion">Mall Champion</option>
                      <option value="Flagship Store">Flagship Store</option>
                      <option value="Both">Both</option>
                    </Form.Select>
                    {isError.program_participation && (
                      <div className="form-error">
                        Please select Maya Mall Program participation type.
                      </div>
                    )}
                  </Form.Group>
                  )}

                  {primaryDetails.program_participation !==
                    "Flagship Store" && (
                    <>
                      {/* Preferred preferred_incentive */}
                      <Form.Group
                        className="mb-4"
                        controlId="preferred_incentive"
                      >
                        <Form.Label className="form-label">
                          Preferred Incentive{" "}
                          <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Select
                          name="preferred_incentive"
                          value={primaryDetails.preferred_incentive || ""}
                          onChange={handleInputChange}
                          className={`form-input ${isError.preferred_incentive ? "form-input-error" : ""}`}
                        >
                          <option value="">-- Select an option --</option>
                          <option value="Maya Credits">Maya Credits</option>
                          <option value="Merienda">Merienda</option>
                        </Form.Select>
                        {isError.preferred_incentive && (
                          <div className="form-error">
                            Please select preferred incentive.
                          </div>
                        )}
                      </Form.Group>

                      {/* Mobile No. */}
                      <Form.Group className="mb-4" controlId="mobile_number">
                        <Form.Label className="form-label">
                          Mobile No. <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="mobile_number"
                          value={primaryDetails.mobile_number || ""}
                          onChange={handleInputChange}
                          placeholder="Enter mobile number"
                          className={`form-input ${isError.mobile_number ? "form-input-error" : ""}`}
                        />
                        {isError.mobile_number && (
                          <div className="form-error">
                            Mobile number is required.
                          </div>
                        )}
                      </Form.Group>

                      {/* Total no. of terminals */}
                      {/* <Form.Group className="mb-4">
                        <Form.Label className="form-label">
                          Total no. of terminals that will join{" "}
                          <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="total_terminals_joined"
                          value={primaryDetails.total_terminals_joined || ""}
                          onChange={handleInputChange}
                          placeholder="Short answer text"
                          className={`form-input ${isError.total_terminals_joined ? "error" : ""}`}
                        />
                        {isError.total_terminals_joined && (
                          <div className="form-error">
                            Please enter total number of terminals.
                          </div>
                        )}
                      </Form.Group> */}

                      {/* MID of terminals that will join */}
                      {/* <Form.Group
                        className="mb-4"
                        controlId="mid_terminals_joined"
                      >
                        <Form.Label className="form-label">
                          MID of terminals that will join{" "}
                          <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="mid_terminals_joined"
                          value={primaryDetails.mid_terminals_joined || ""}
                          onChange={handleInputChange}
                          placeholder="Enter MID of terminals"
                          className={`form-input ${isError.mid_terminals_joined ? "form-input-error" : ""}`}
                        />
                        {isError.mid_terminals_joined && (
                          <div className="form-error">
                            MID of terminals is required.
                          </div>
                        )}
                      </Form.Group> */}

                      {/* Total no. of static QR - Hidden for DCC only */}
                      {/* {primaryDetails.joined_maya_program !== "Yes, DCC only" && (
                        <Form.Group className="mb-4">
                          <Form.Label className="form-label">
                            Total no. of static QR (SQR) that will join{" "}
                            <span className="form-required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="total_sqr_joined"
                            value={primaryDetails.total_sqr_joined || ""}
                            onChange={handleInputChange}
                            placeholder="Short answer text"
                            className={`form-input ${isError.total_sqr_joined ? "error" : ""}`}
                          />
                          {isError.total_sqr_joined && (
                            <div className="form-error">
                              Please enter total number of static QR.
                            </div>
                          )}
                        </Form.Group>
                      )} */}

                      {/* Store code of static QR (SQR) that will join - Hidden for DCC only */}
                      {/* {primaryDetails.joined_maya_program !== "Yes, DCC only" && (
                        <Form.Group className="mb-4" controlId="store_code_sqr">
                          <Form.Label className="form-label">
                            Store code of static QR (SQR) that will join{" "}
                            <span className="form-required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="store_code_sqr"
                            value={primaryDetails.store_code_sqr || ""}
                            onChange={handleInputChange}
                            placeholder="Enter store code"
                            className={`form-input ${isError.store_code_sqr ? "form-input-error" : ""}`}
                          />
                          {isError.store_code_sqr && (
                            <div className="form-error">
                              Store code of SQR is required.
                            </div>
                          )}
                        </Form.Group>
                      )} */}

                      {/* POC Name */}
                      {/* <Form.Group className="mb-4" controlId="poc_name">
                        <Form.Label className="form-label">
                          POC Name <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="poc_name"
                          value={primaryDetails.poc_name || ""}
                          onChange={handleInputChange}
                          placeholder="Enter POC name"
                          className={`form-input ${isError.poc_name ? "form-input-error" : ""}`}
                        />
                        {isError.poc_name && (
                          <div className="form-error">
                            POC name is required.
                          </div>
                        )}
                      </Form.Group> */}

                      {/* POC Position */}
                      {/* <Form.Group className="mb-4" controlId="poc_position">
                        <Form.Label className="form-label">
                          POC Position <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="poc_position"
                          value={primaryDetails.poc_position || ""}
                          onChange={handleInputChange}
                          placeholder="Enter POC position"
                          className={`form-input ${isError.poc_position ? "form-input-error" : ""}`}
                        />
                        {isError.poc_position && (
                          <div className="form-error">
                            POC position is required.
                          </div>
                        )}
                      </Form.Group> */}

                      {/* Date signed trade letter */}
                      <Form.Group className="mb-4">
                        <Form.Label className="form-label">
                          Date signed the AR
                          <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="date_signed"
                          value={primaryDetails.date_signed || ""}
                          onChange={handleInputChange}
                          className={`form-input ${isError.date_signed ? "error" : ""}`}
                        />
                        {isError.date_signed && (
                          <div className="form-error">
                            Please select the date signed trade letter.
                          </div>
                        )}
                      </Form.Group>
                    </>
                  )}

                  {!["Mall Champion", "Both"].includes(primaryDetails.program_participation) && (
                  <Form.Group
                    className="mb-4"
                    controlId="reason_not_joined_mall_champion"
                  >
                    <Form.Label className="form-label">
                      Reason for not Joining Mall Champion{" "}
                      <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="reason_not_joined_mall_champion"
                      value={primaryDetails.reason_not_joined_mall_champion || ""}
                      onChange={handleInputChange}
                      placeholder="Enter reason"
                      className={`form-input ${isError.reason_not_joined_mall_champion ? "form-input-error" : ""}`}
                    />
                    {isError.reason_not_joined_mall_champion && (
                      <div className="form-error">Reason is required.</div>
                    )}
                  </Form.Group>
                )}

                  <Form.Group
                    className="mb-5"
                    controlId="joined_maya_kita_club"
                  >
                    <Form.Label className="form-label">
                      Joined Maya Kita Club?
                      <span className="form-required">*</span>
                    </Form.Label>

                    <Form.Select
                      name="joined_maya_kita_club"
                      value={primaryDetails.joined_maya_kita_club || ""}
                      onChange={handleInputChange}
                      className={`form-input ${isError.joined_maya_kita_club ? "form-input-error" : ""}`}
                    >
                      <option value="">-- Select an option --</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                      {/* <option value="Needs HQ approval">Needs HQ approval</option>
                                        <option value="Authorized person not available">Authorized person not available</option>
                                        <option value="Undecided - for revisit">Undecided - for revisit</option> */}
                    </Form.Select>

                    {isError.joined_maya_kita_club && (
                      <div className="form-error">
                        Please answer if merchant wants to join the Maya Kita
                        Club.
                      </div>
                    )}
                  </Form.Group>

                  {primaryDetails.joined_maya_kita_club === "Yes" && (
                    <Form.Group className="mb-4" controlId="facebook_accnt_name">
                      <Form.Label className="form-label">
                        Facebook Account Name{" "}
                        <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="facebook_accnt_name"
                        value={primaryDetails.facebook_accnt_name || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Facebook account name"
                        className={`form-input ${isError.facebook_accnt_name ? "form-input-error" : ""}`}
                      />
                      {isError.facebook_accnt_name && (
                        <div className="form-error">Facebook account name is required.</div>
                      )}
                    </Form.Group>
                  )}

                  {primaryDetails.joined_maya_kita_club === "No" && (
                    <Form.Group
                      className="mb-4"
                      controlId="reason_not_joined_maya_kita_club"
                    >
                      <Form.Label className="form-label">
                        Reason for not joining MKC{" "}
                        <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="reason_not_joined_maya_kita_club"
                        value={
                          primaryDetails.reason_not_joined_maya_kita_club || ""
                        }
                        onChange={handleInputChange}
                        placeholder="Enter reason"
                        className={`form-input ${isError.reason_not_joined_maya_kita_club ? "form-input-error" : ""}`}
                      />
                      {isError.reason_not_joined_maya_kita_club && (
                        <div className="form-error">Reason is required.</div>
                      )}
                    </Form.Group>
                  )}

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default JoiningMayaMallProgramSection72;
